module.exports = __webpack_public_path__ + "static/media/tus_logo.69db938a.svg";